/*
 * @Author: 刘枫
 * @Date: 2020-10-30 14:20:39
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-05-24 12:21:24
 */

<template>

  <div id="header">
    <div class="layout">
      <h1 id="shop-logo" v-if="isHasShop">
        <router-link :to="{ path: 'shop', query: { tab:1,store_id: HeadData.storeId}}" class="mall-home" title="首页">
          <img :src="HeadData.storeLogo" class="pngFix" />
        </router-link>
        <em>{{HeadData.storeName}}</em>
      </h1>
      <div class="shop-head-info" id="jsddm">
        <div class="search" id="shop-info">
          <form method="get" name="formSearch" id="formSearch" action="home.html">
            <input name="act" id="search_act" value="search" type="hidden">
            <input type="hidden" name="store_id" value="2553">
            <input type="hidden" name="show_c" value="4">
            <input name="keyword" id="keyword" type="text" class="ncs-search-input-text" v-model="keyword"
              placeholder="想找什么商品？">
            <a class="ncs-search-btn-mall" v-on:click="search('all')"><span>全站搜</span></a>
            <a class="ncs-search-btn-shop" v-on:click="search('inside')"><span>店内搜</span></a>
          </form>
        </div>
        <!-- <div class="service">
          <i></i>客服<em></em>
          <div class="arrow"></div>
          <div class="sub">
            <div class="ncs-message-bar">
              <div class="default">
                <h5><a target="_blank" href="/webimRy/storeCs.html?store_id=2553">客服中心</a></h5>
              </div>
              <div class="service-list">
                <dl>
                  <dt>客服中心</dt>
                  <dd>
                      <p>QQ：
                        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3414254320&site=qq&menu=yes">
                          <img src="http://wpa.qq.com/pa?p=2:1234567:52" alt="">
                        </a>
                      </p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>-->
        <div class="favorites">
          <i></i>收藏<em></em>
          <div class="arrow"></div>
          <div class="sub">
            <div class="title-bar">
              <h3>店铺空间</h3>
            </div>
            <ul>
              <li>
                <a id="collect_id" class="btn" v-on:click="addCollection()"><i class="collected"></i>收藏</a>
              </li>
              <li>
                <a style="text-decoration: none" nctype="store_collect"
                  class="store_collect">{{HeadData.storeCollect}}</a><span>收藏人气</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addStoreCollections } from 'api/shop.js';
export default {
  props: {
    HeadData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isHasShop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keyword: '',
      json: []
    }
  },
  watch: {
    keyword: function () {
      this.$emit('newKeyword', this.keyword)
    }
  },
  created() {
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
  },
  methods: {
    search: function (type) {
      if (!this.keyword) {
        this.$Message.info('请输入您要搜索的商品关键字');
        return;
      }
      if (type == 'all') {
        this.$router.push({ path: '/goods-list', query: { keyword: this.keyword } });
      } else if (type == 'inside') {
        this.$emit('getShopListData')
      }
    },
    addCollection: function () {
      if (this.$store.getters.sid == '' || !this.$store.getters.sid) {
        this.$Message.info('请先登录');
      } else {
        let data = {
          storeId: this.HeadData.storeId,
          type: 2
        }
        addStoreCollections(data).then((json) => {
          if (json.resCode == '1') {
            this.$Message.info(json.resDesc);
            this.$emit('applyHeadData')
          } else {
            this.$Message.info(json.resDesc);
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// shop_header.vue?aa88db72